import { render, staticRenderFns } from "./HongKongTrust.vue?vue&type=template&id=f628e0bc&scoped=true&"
import script from "./HongKongTrust.vue?vue&type=script&lang=js&"
export * from "./HongKongTrust.vue?vue&type=script&lang=js&"
import style0 from "./HongKongTrust.vue?vue&type=style&index=0&id=f628e0bc&prod&lang=scss&scoped=true&"
import style1 from "./HongKongTrust.vue?vue&type=style&index=1&id=f628e0bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f628e0bc",
  null
  
)

export default component.exports